import { L } from '@lib';
import { Button, Col, Layout, Row, Typography } from 'antd';
import React from 'react';
import { TechnicalCategoryContent, TechnicalCategoryMenu } from '../TechnicalCategories';
import { useView } from '@hooks';

const { Content, Sider } = Layout;
const { Title } = Typography;

interface IProps {
  vin: string;
  category: string;
  bookmarked: boolean;
  showBookmark: boolean;
  selectedCategoryId: string;
  technicalCategoryName?: string;
  setCategory: (category: string) => void;
  onBookmarkClick: () => void;
  onBackClick: () => void;
}

const VehicleHowToDoIt: React.FC<IProps> = ({
  vin,
  category,
  bookmarked,
  selectedCategoryId,
  technicalCategoryName,
  setCategory,
  onBookmarkClick,
  onBackClick,
}) => {
  const { isMobile } = useView();
  return (
    <>
      <Row justify="space-between" align="middle">
        <Col>{L('Your vehicle model')}</Col>
        {selectedCategoryId && category && (
          <>
            <Col>
              <Title level={2}>{technicalCategoryName}</Title>
            </Col>
            <Col>
              <Button disabled={bookmarked} type="text" onClick={onBookmarkClick}>
                {(bookmarked && L('Bookmarked')) || L('Bookmark')}
              </Button>
            </Col>
          </>
        )}
      </Row>
      <br />
      <div style={{ width: '100%' }}>
        {isMobile ? (
          selectedCategoryId ? (
            <div style={{ width: '100%' }}>
              <Button type="default" onClick={onBackClick} style={{ marginBottom: 16 }}>
                {L('Back to categories')}
              </Button>
              <TechnicalCategoryContent category={category} />
            </div>
          ) : (
            <TechnicalCategoryMenu vin={vin} category={category} setCategory={setCategory} />
          )
        ) : (
          <Layout hasSider>
            <Sider width={350} theme="light">
              <TechnicalCategoryMenu vin={vin} category={category} setCategory={setCategory} />
            </Sider>
            <Content style={{ background: 'white', padding: '0 24px', minHeight: 400 }}>
              {category && <TechnicalCategoryContent category={category} />}
            </Content>
          </Layout>
        )}
      </div>
    </>
  );
};

export default VehicleHowToDoIt;
